<template>
	<v-container>
		<v-row class="text-center">
			<v-col cols="12" class="d-flex flex-column align-center justify-center ga-4">
				<v-card elevation="0" loading variant="text" class="w-100">
					<v-card-text class="text-subtitle-1 text-grey-darken-1">
						{{ message || "Loading, please wait..." }}
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: "LoadingPage",
		props: {
			message: {
				type: String,
				default: ""
			}
		}
	};
</script>
